import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex: 1;
  justify-content: left;
  flex-wrap: wrap;
  margin: 15px;
`;

export const Title = styled.div`
  font-weight: bold;
  font-size: 20px;
  margin-bottom: 10px;
  color: white;
  text-decoration: capitalize;
  `;

export const Subtitle = styled.div`
  font-weight: normal;
  font-size: 15px;
  color: white;
`;
